module.exports = __webpack_public_path__ + "static/media/inviteBg.60e6c9c7.png";